import {Box, Typography} from '@mui/material';
import {useTranslation} from 'react-i18next';

import {AppProgressButton} from '@/app/shared-components';

import {
  useVirtualCardReadyViewModelProvider,
  VirtualCardReadyViewModelProvider,
} from './ViewModelContext';

import './styles';

const VirtualCardReadyContent = () => {
  const {t} = useTranslation();
  const {cardTheme, handleButtonAction} =
    useVirtualCardReadyViewModelProvider();

  return (
    <Box className="virtual-card-ready-page-container">
      <section className="virtual-card-ready-page-content">
        <img
          src={cardTheme}
          alt="Virtual Card"
          width={350}
        />
        <section className="virtual-card-ready-page-text-content">
          <Typography className="virtual-card-ready-page-text">
            {t('virtual_card_ready.title')}
          </Typography>

          <Typography className="virtual-card-ready-page-subtext">
            {t('virtual_card_ready.sub_title')}
          </Typography>
        </section>
      </section>

      <AppProgressButton
        label={t('virtual_card_ready.button')}
        onProgressEnds={handleButtonAction}
        onPress={handleButtonAction}
      />

      <section className="virtual-card-ready-disclaimer-content">
        <Typography className="virtual-card-ready-disclaimer-text">
          {t('virtual_card_ready.disclaimer_1')}
        </Typography>

        <Typography className="virtual-card-ready-disclaimer-text">
          {t('virtual_card_ready.disclaimer_2')}
        </Typography>
      </section>
    </Box>
  );
};

const VirtualCardReadyPage = () => (
  <VirtualCardReadyViewModelProvider>
    <VirtualCardReadyContent />
  </VirtualCardReadyViewModelProvider>
);

export default VirtualCardReadyPage;
